import WhyStreamYardScene from '../../scenes/MarketingPages/scenes/WhyStreamYard';

export default WhyStreamYardScene;
